export default "__VITE_ASSET__DDEv3Hlt__";